import "./ZirconiumCoating.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import AboutMe from "./sections/AboutMe";
import TreatmentDetails from "./sections/TreatmentDetails";
import Footer from "@/reusable_sections/Footer";
export default function ZirconiumCoatingPage() {
  return <div>
      <Header />
      <Hero />
      <AboutMe />
      <TreatmentDetails />
      <Footer />
    </div>;
}